import Api from "@/configurations/Api";
import RequestService from "@/configurations/AxiosConfig";
import { ICreateFormRequest, IExportFormSubmissionToPdfAndExcelRequest, IGetSubmissionRequest, ISendFormSubmissionEmailRequest, IUpdateFormRequest } from "@/types/type";
import { toast } from "sonner";

const endpoints = {
  forms: 'forms',
  getSubmissionByBranchAndOfficer: 'forms/submissions',
  getFormDetailBySubmissionId: 'forms/getFormDetailBySubmissionId',
  getFormDetailById: 'forms/getFormDetail',
};

const FormsService = {
  getAllForms: async () => RequestService.get(endpoints.forms),
  createFormSubmission: (data: ICreateFormRequest) => RequestService.post(`${endpoints.forms}/createFormSubmission`, data),
  updateFormAnswers: (data: IUpdateFormRequest) => RequestService.patch(`${endpoints.forms}/updateFormAnswers`, data),
  getSubmissionByBranchAndOfficer: (data: IGetSubmissionRequest) => RequestService.post(endpoints.getSubmissionByBranchAndOfficer, data),
  getFormDetailBySubmissionId: async (submissionId: string | number) => RequestService.get(`${endpoints.getFormDetailBySubmissionId}/${submissionId}`),
  getFormDetailById: async (id: string | number) => RequestService.get(`${endpoints.getFormDetailById}/${id}`),
  getSubmissionByFormId: async (id: string | number) => RequestService.get(`${endpoints.forms}/getSubmissionByFormId/${id}`),
  getSubmissionByFormIdAndCompanyId: async (id: string | number, companyId: string | number) => RequestService.get(`${endpoints.forms}/getSubmissionByFormIdAndCompanyId/${id}/${companyId}`),
  sendFormSubmissionEmail: async (data: ISendFormSubmissionEmailRequest) => RequestService.post(`${endpoints.forms}/sendFormSubmissionEmail`, data ),
  exportFormSubmissionToExcel: async (id: IExportFormSubmissionToPdfAndExcelRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}forms/exportFormSubmissionToExcel/${id}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      // body: JSON.stringify(data)
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("excel")) {
      console.warn("Response might not be an Excel file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'form_submission.xlsx'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  },
  exportFormSubmissionToPdf: async (id: IExportFormSubmissionToPdfAndExcelRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}forms/exportFormSubmissionToPdf/${id}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("pdf")) {
      console.warn("Response might not be a PDF file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'form_submission.pdf'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  }
};

export default FormsService;
